import React from 'react';
import { Alert } from '@mui/material';
import { FlashOn } from '@mui/icons-material';
import { useBlaalysMode } from '../context/BlaalysModeContext';

export default function BlaalysModeBanner() {
  const { allowBlaalysOverride, loading } = useBlaalysMode();

  if (loading || !allowBlaalysOverride) {
    return null;
  }

  return (
    <Alert
      severity="error"
      icon={<FlashOn />}
      sx={{
        borderRadius: 0,
        py: 0.5,
        '& .MuiAlert-message': { width: '100%', textAlign: 'center' }
      }}
    >
      Blålysmodus er på — påloggede blålystelefoner kan åpne låser uten tilgangsgruppe.
    </Alert>
  );
}
